// alarmSnapshot.js
// Persistência do retrato de níveis de alarme na sessão do navegador.
//
// Só o retrato (ToSenseID -> nível) é persistido; avisos ativos não são. É
// exatamente esse recorte que faz um reload não gerar aviso novo para um ativo
// que já estava crítico, sem ressuscitar avisos que o operador já tratou.
//
// LGPD: guarda identificador de ativo e nível de alarme. Nenhum dado pessoal,
// nenhum token, nenhuma credencial.

// A chave é escopada por operador. Sem isso, trocar de usuário na mesma aba faz
// o operador B herdar o retrato do operador A — e ter suprimidas as primeiras
// notificações de ativos que, para ele, ainda eram desconhecidos.
const STORAGE_PREFIX = "overview.alarmes-criticos.retrato";

const keyFor = (scope) => `${STORAGE_PREFIX}.${scope || "anonimo"}`;

export const loadSnapshot = (scope) => {
  try {
    const raw = window.sessionStorage.getItem(keyFor(scope));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    // Descarta qualquer entrada fora da escala 0/1/2, para que um retrato
    // corrompido não vire nível "conhecido" e suprima um aviso legítimo.
    return Object.fromEntries(
      Object.entries(parsed).filter(([, level]) => [0, 1, 2].includes(level)),
    );
  } catch {
    return {};
  }
};

export const saveSnapshot = (scope, snapshot) => {
  try {
    window.sessionStorage.setItem(keyFor(scope), JSON.stringify(snapshot));
  } catch {
    // Sessão sem armazenamento disponível não pode derrubar a notificação:
    // sem retrato persistido a feature segue operando dentro da aba viva.
  }
};

export const clearSnapshot = (scope) => {
  try {
    window.sessionStorage.removeItem(keyFor(scope));
  } catch {
    // Idem: falha ao limpar não é condição de erro para o operador.
  }
};
